import StartIcon from '@mui/icons-material/Start';
import {
    usePortfolioManagement,
    usePortfolioProfile,
    usePortfolioSelection,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";
import { ToolsPanelToggleButton } from "../../positions-and-orders/controls";

export function SessionBalanceAsZeroToggle() {
    const {
        selectedPortfolio,
    } = usePortfolioSelection();
    const {
        saveSelectedPortfolio,
    } = usePortfolioManagement();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();

    const value = selectedPortfolio?.portfolioSettings?.useSessionBalanceAsZero ?? false;

    const onChange = async (): Promise<void> => {
        if (selectedPortfolio?.portfolioSettings === null || selectedPortfolio?.portfolioSettings === undefined) {
            return;
        }

        selectedPortfolio.portfolioSettings.useSessionBalanceAsZero = !value;
        updateSelectedPortfolio();
        await saveSelectedPortfolio();
    };

    return (
        <ToolsPanelToggleButton
            isActivated={value}
            setIsActivated={onChange}
            tooltipTextWhenActivated="Do not use session balance as zero"
            tooltipTextWhenDeactivated="Use session balance as zero"
        >
            <StartIcon
                sx={{
                    height: '18px',
                    width: '18px',
                    transform: 'rotate(270deg)',
                }}
            />
        </ToolsPanelToggleButton>
    );
}
